import Layout from '@plat/views/event/attendee/invitation/Layout'
import InvitationMessage from '@plat/views/event/attendee/invitation/InvitationMessage'

export default [
  {
    path: '/',
    component: Layout,
    redirect: 'success',
    children: [{
      path: 'success',
      component: InvitationMessage,
      name: 'invitationDeclined'
    }, {
      path: 'reject',
      component: InvitationMessage,
      name: 'invitationReject'
    }, {
      path: 'closed',
      component: InvitationMessage,
      name: 'invitationExpired'
    }]
  }
]
